var SelectField = require('modules/select-field');
var Filters = require('modules/custom-filters');
var svgPanZoom = require('svg-pan-zoom');

function Directory(el) {
	var t = this,
		selectFieldEl = el.querySelector('.js-directory-dropdown'),
		selectFieldElMobile = selectFieldEl.querySelector('[data-field-mobile]'),
		selectFieldElCurrent = selectFieldEl.querySelector('[data-field-current]'),
		selectComponent = new SelectField(selectFieldEl),
		filtersComponent = new Filters(el);

	t.el = el;
	t.map = t.el.querySelector('.js-directory-map-filters svg');
	t.panzoom = null;

	if( t.map ) {
		var options = {
			zoomEnabled: true,
			contain: true,
			fit: true,
			controlIconsEnabled: false,
			minZoom: 1,
			maxZoom: 10,
			beforePan: function( oldPan, newPan ){
				var currentZoom = t.panzoom.getZoom();
				if (currentZoom <= 1.00001) {
					return {x: 0, y:0};
				}

				var sizes = this.getSizes(),
					leftLimit = 0,
					rightLimit = -(sizes.width * (currentZoom - 1)),
					topLimit = 0,
					bottomLimit = -(sizes.height * (currentZoom - 1));

				return {
					x: Math.min(leftLimit, Math.max(rightLimit, newPan.x)),
					y: Math.min(topLimit, Math.max(bottomLimit, newPan.y))
				}
			}
		},
		height = t.map.getBoundingClientRect().height;

		if( height ) {
			t.map.parentNode.style.height = height + 'px';
		}
		t.panzoom = svgPanZoom(t.map, options);
		t.zoomInButton = t.el.querySelector('[data-zoom-in]');
		t.zoomOutButton = t.el.querySelector('[data-zoom-out]');

		if( t.zoomInButton ) {
			t.zoomInButton.addEventListener('click', function(event) {
				event.preventDefault();
				t.panzoom.zoomIn();
			});
		}

		if( t.zoomOutButton ) {
			t.zoomOutButton.addEventListener('click', function(event) {
				event.preventDefault();
				t.panzoom.zoomOut();
			});
		}

		// move svg using arrow key.
		t.getPoint = function(x, y) {
			var pt = t.map.createSVGPoint();
			pt.x = x;
			pt.y = y;

			return pt.matrixTransform(t.map.getScreenCTM().inverse());
		};

		t.keyboardHandlers = function(e) {
			var key = e.which || e.keyCode,
				step = 15;

			if (key >= 37 && key <= 40) {
				e.preventDefault();
			}

			switch (key) {
				case 37:	// left
					t.panzoom.panBy({x: step, y: 0});

					break;
				case 38:	// up
					t.panzoom.panBy({x: 0, y: step});

					break;
				case 39:	// right
					t.panzoom.panBy({x: -step, y: 0});

					break;
				case 40:	// down
					t.panzoom.panBy({x: 0, y: -step});

					break;
			}
		};

		t.zoomInButton.addEventListener('keydown', t.keyboardHandlers);
		t.zoomOutButton.addEventListener('keydown', t.keyboardHandlers);
	}

	window.pz = t.panzoom;



	// Generate array list for SVG groups
	if( selectFieldElMobile ) {
		t.list = Array.prototype.slice.call( selectFieldElMobile.children );
		t.svgIDs = [];
		t.list.forEach( function(item) {
			var value = item.getAttribute('value');
			if( value ) {
				value.split('|').map(function(singleValue) {
					t.svgIDs.push(singleValue);
				});
			}
		});
	}

	// Check and append data filter to matching filter group
	if( t.svgIDs && t.map ) {
		t.svgGroups = Array.prototype.slice.call( t.map.querySelectorAll('g'));
		if( t.svgGroups ) {
			t.svgGroups.forEach( function(group) {
				var id = group.getAttribute('id');
				if( t.svgIDs.indexOf(id) != -1) {
					group.setAttribute('data-filter', id);
				}
			} );
		}
	}

	filtersComponent.filterByValue(selectFieldElMobile.value);
	selectComponent.onChange(filtersComponent.filterByValue.bind(filtersComponent));
}
module.exports = Directory;
